import React, { useEffect, useState } from 'react'
import { Button, Col, Drawer, DrawerProps, Form, Row, Table } from 'antd'
import { assignErrorToInput } from '../../../../../../store/api';
import { rules } from '../Form/rules';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import CommonModal from '../../../../../../components/Modals/CommonModal';
import { CONSTANT } from '../../../../../../config/Constant';
import { PlusOutlined } from "@ant-design/icons";
import { useAppDispatch } from '../../../../../../store/app';
import { FormBox, InputBox } from '../../../../../../components/AntdAddons';
import { tablePagination, validateFields } from '../../../../../../config/Global';
import { addVillageUnavailableServices, deleteVillageUnavailableServices, getUnavailableServicesList, updateVillageUnavailableServices } from '../../utils/slice';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
interface VillageUnavailableServicesDrawerProps extends DrawerProps {
    saveAndNext: any;
    open: any;
    villageId: any;
    dynamicSteps: any;
    villageDetailsId: any
    close: () => void;
}
const VillageUnavailableServices: React.FC<VillageUnavailableServicesDrawerProps> = ({
    close,
    open,
    saveAndNext,
    villageId,
    dynamicSteps,
    villageDetailsId,
    ...rest
}) => {
    const { t } = useTranslation();
    const { action } = useParams();
    const dispatch = useAppDispatch();
    const [addEditForm] = Form.useForm();
    const [disabled, setDisabled] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [villageUnavailableServicesList, setVillageUnavailableServicesList] = useState<any>([]);
    const [openDeleteModal, setOpenDeleteModal] = useState<any>();
    const [openAddEditModal, setOpenAddEditModal] = useState<any>();
    const [openAddEditForm, setOpenAddEditForm] = useState<any>();
    const [pagination, setPagination] = useState(tablePagination);
    const columns = [
        {
            title: `${t("VILLAGEMANAGEMENT.TYPE")}`,
            dataIndex: 'service_type',
            key: 'service_type',
        },
        {
            title: `${t("VILLAGEMANAGEMENT.DETAIL")}`,
            dataIndex: 'service_detail',
            key: 'service_detail',
        },
        {
            title: `${t("GENERAL.ACTIONS")}`,
            key: 'action',
            render: (text: any, record: any) => (
                <div className='listActionbtn'>
                    <span onClick={() => handleAddEdit(record, "editModal")}>
                        <EditOutlined />
                    </span>
                    <span onClick={() => deleteModal(record)}>
                        <DeleteOutlined />
                    </span>
                </div>
            ),
        },
    ];
    useEffect(() => {
        if (villageDetailsId && action === CONSTANT.DRAWER_TYPE.EDIT && dynamicSteps === CONSTANT.STEP.VILLAGE_UNAVAILABLE_SERVICES) {
            dispatch(getUnavailableServicesList({ village_detail_id: villageDetailsId, village_id: villageId }))
                .then((res: any) => {
                    if (res.count > 0) {
                        setVillageUnavailableServicesList([...res.rows])
                    } else {
                        setVillageUnavailableServicesList(res.rows)
                    }
                })
                .catch((e: any) => e)
        }
    }, [dynamicSteps])
    const drawerClose = (submitForm = "") => {
        if (submitForm === "") {
            close()
        } else {
            saveAndNext(CONSTANT.STEP.VILLAGE_PROBLEM)
        }
        setVillageUnavailableServicesList([])
        addEditForm.resetFields();
        setDisabled(true);
    }
    const handleAddEdit = (data: any, openForm: any) => {
        setOpenAddEditForm(openForm)
        if (openForm === "editModal") {
            const setValues = villageUnavailableServicesList.find((item: any) => item.id === data.id);
            addEditForm.setFieldsValue({
                ...setValues
            })
            setOpenAddEditModal(data)
        } else {
            setOpenAddEditModal(true)
        }
    }
    const deleteModal = (data: any) => {
        setOpenDeleteModal(data)
    }
    const closeEditModal = () => {
        setOpenAddEditModal(null)
        addEditForm.resetFields();
        setDisabled(true);
    }
    const validateEditForm = () => {
        validateFields(addEditForm, setDisabled);
    };
    const handleUpdateVillageUnavailableServicesListForm = (data: any) => {
        setSaving(true)
        data.village_id = villageId
        data.village_detail_id = villageDetailsId
        if (openAddEditForm === "editModal") {
            dispatch(updateVillageUnavailableServices(openAddEditModal.id, data))
                .then((res: any) => {
                    const indexToUpdate = villageUnavailableServicesList.findIndex((item: any) => item.id === res.data.id);
                    if (indexToUpdate !== -1) {
                        const updatedvillageUnavailableServicesList = [...villageUnavailableServicesList];
                        updatedvillageUnavailableServicesList[indexToUpdate] = res.data;
                        setVillageUnavailableServicesList(updatedvillageUnavailableServicesList);
                    }
                    setSaving(false)
                    closeEditModal();
                })
                .catch((error: any) => {
                    assignErrorToInput(addEditForm, error?.STATUS);
                    setSaving(false)
                })
                .finally(() => setSaving(false));
        } else {
            dispatch(addVillageUnavailableServices(data))
                .then((res: any) => {
                    setVillageUnavailableServicesList([res.data, ...villageUnavailableServicesList])
                    closeEditModal();
                    addEditForm.resetFields();
                    setSaving(false);
                })
                .catch((error: any) => {
                    assignErrorToInput(addEditForm, error?.STATUS);
                    setSaving(false)
                })
                .finally(() => setSaving(false));
        }
    }
    const closeDeleteModal = () => {
        setOpenDeleteModal(null)
    }
    const deleteData = () => {
        setSaving(true)
        dispatch(deleteVillageUnavailableServices(openDeleteModal.id, openDeleteModal))
            .then(() => {
                const deleteData = villageUnavailableServicesList.filter((item: any) => item.id !== openDeleteModal.id)
                setVillageUnavailableServicesList(deleteData)
                setOpenDeleteModal(null)
                setSaving(false)
            })
            .catch((error: any) => error)
            .finally(() => setSaving(false));
    }
    return (
        <>
            <Drawer
                title={`${t("VILLAGEMANAGEMENT.VILLAGE_UNAVAILABLE_SERVICES")}`}
                placement="right"
                onClose={() => drawerClose()}
                open={open}
                className='villageInnerPages'
                width={"70%"}
                footer={[
                    <Button
                        key="2"
                        htmlType="button"
                        className="cancelBtn"
                        onClick={() => drawerClose()}
                    >
                        {t("GENERAL.CANCEL_BUTTON")}
                    </Button>,
                    <Button
                        key="3"
                        type="primary"
                        onClick={() => drawerClose("saveAndNext")}
                    >
                        {t("GENERAL.CONTINUE_BUTTON")}
                    </Button>
                ]}
                {...rest}
            >
                <div className='add_modal_button'>
                    <Button
                        key="3"
                        type="primary"
                        onClick={() => handleAddEdit(null, "addModal")}
                    >
                        {t("GENERAL.ADD_DRAWER_TITLE")} <PlusOutlined />
                    </Button>
                </div>
                <Table
                    dataSource={villageUnavailableServicesList}
                    columns={columns}
                    onChange={(pagination: any) => setPagination(pagination)}
                    pagination={pagination} // Apply pagination configuration
                />
                <CommonModal
                    open={openDeleteModal}
                    className={"deleteModal"}
                    title={`${t("VILLAGEMANAGEMENT.VILLAGE_UNAVAILABLE_SERVICES")} ${t("GENERAL.DELETE__DRAWER_TITLE")}`}
                    onCancel={closeDeleteModal}
                    footer={[
                        <Button key="2" htmlType="button" className="cancelBtn" onClick={closeDeleteModal}>
                            {t("GENERAL.CLOSE_BUTTON")}
                        </Button>,
                        <Button
                            key="1"
                            type="primary"
                            loading={saving}
                            htmlType='submit'
                            onClick={deleteData}
                        >
                            {t("GENERAL.DELETE_BUTTON")}
                        </Button>
                    ]}
                >
                    <div className="deleteNote">
                        {t("GENERAL.DELETE_MODEL_MESSAGE")} <span>{openDeleteModal?.service_type}</span>?
                    </div>
                </CommonModal>
                <CommonModal
                    open={openAddEditModal}
                    title={openAddEditForm === "editModal" ? `${t("VILLAGEMANAGEMENT.VILLAGE_UNAVAILABLE_SERVICES")} ${t("GENERAL.EDIT__DRAWER_TITLE")}` : `${t("VILLAGEMANAGEMENT.VILLAGE_UNAVAILABLE_SERVICES")} ${t("GENERAL.ADD_DRAWER_TITLE")}`}
                    onCancel={closeEditModal}
                    footer={[
                        <Button key="2" htmlType="button" className="cancelBtn" onClick={closeEditModal}>
                            {t("GENERAL.CLOSE_BUTTON")}
                        </Button>,
                        <Button
                            key="1"
                            type="primary"
                            loading={saving}
                            htmlType='submit'
                            disabled={disabled}
                            form='villageUnavailableServicesListForm'
                        >
                            {t("GENERAL.SAVE_BUTTON")}
                        </Button>
                    ]}
                >
                    <FormBox
                        form={addEditForm}
                        id="villageUnavailableServicesListForm"
                        onValuesChange={validateEditForm}
                        onFinish={handleUpdateVillageUnavailableServicesListForm}
                    >
                        <Row gutter={15}>
                            <Col sm={24} md={24}>
                                <InputBox.Text
                                    required
                                    label={t("VILLAGEMANAGEMENT.TYPE")}
                                    name="service_type"
                                    placeholder={t("VILLAGEMANAGEMENT.TYPE")}
                                    rules={rules.name()}
                                />
                            </Col>
                            <Col sm={24} md={24}>
                                <InputBox.Text
                                    required
                                    label={t("VILLAGEMANAGEMENT.DETAIL")}
                                    name="service_detail"
                                    placeholder={t("VILLAGEMANAGEMENT.DETAIL")}
                                    rules={rules.name()}
                                />
                            </Col>
                        </Row>
                    </FormBox>
                </CommonModal>
            </Drawer>
        </>
    )
}
export default VillageUnavailableServices